import React, { useEffect, useRef, useState } from 'react';
import backicon from './../../../../../../Assets/icons/backIcon.svg';
// import "./index.scss";
import { useFetcher, useNavigate } from 'react-router-dom';
import DynamicForm from '../../../../../customformComponent/customForm/DynamicForm';
import axiosInstance from '../../../../../services/api/API';
import Swal from 'sweetalert2';
import Loader from '../../../../../customComponents/CustomLoader';
import ROUTES_NAVIGATION from '../../../../../../routes/routes';
import { addDays, addMonths, addYears } from 'date-fns';
import validations from '../../../../../../helpers/validations';
import { buttonStyle, isFormValid } from '../../../../../../helpers/common';

const AddWarranty = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [warrantyTypeData, setWarrantyTypeData] = useState([]);
  const [warrantycategory, setWarrantyCategory] = useState([]);

  const prevWarrantyTypeRef = useRef();

  useEffect(() => {
    warrantyType();
    warrantyCategory();
  }, []);
  const warrantyCategory = async () => {
    try {
      const response = await axiosInstance.post(
        '/warrantytype/ddlwarrantycategory',
        {}, // Add an empty object here for the request body
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const data = response.data.data.data;
      const warrantycategoryoptions = data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      setWarrantyCategory(warrantycategoryoptions);
    } catch (error) {
      console.log(error);
    }
  };

  const warrantyType = async () => {
    try {
      const response = await axiosInstance.post(
        '/warrantytype/ddlwarrantytype',
        {}, // Add an empty object here for the request body
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const data = response.data.data.data;
      const warrantyTypeOptions = data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      setWarrantyTypeData(warrantyTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      formData?.warranty_form &&
      formData?.warranty_type &&
      formData?.warranty_value
    ) {
      const warrantyFromDate = new Date(formData?.warranty_form);
      if (isNaN(warrantyFromDate.getTime())) {
        console.error('Invalid warranty_form date');
        return;
      }

      let warrantyToDate;
      switch (formData?.warranty_type) {
        case 'D': // Days
          warrantyToDate = addDays(
            warrantyFromDate,
            parseInt(formData?.warranty_value, 10),
          );
          break;
        case 'M': // Months
          warrantyToDate = addMonths(
            warrantyFromDate,
            parseInt(formData?.warranty_value, 10),
          );
          break;
        case 'Y': // Years
          warrantyToDate = addYears(
            warrantyFromDate,
            parseInt(formData?.warranty_value, 10),
          );
          break;
        default:
          console.error('Invalid warranty type');
          return;
      }
      setFormData((prevData) => ({
        ...prevData,
        warranty_to: warrantyToDate?.toISOString().split('T')[0],
      }));
    }
  }, [
    formData?.warranty_form,
    formData?.warranty_type,
    formData?.warranty_value,
  ]);
  const navigate = useNavigate();
  const authToken = localStorage.getItem('authToken');
  const handleFormSubmit = async (formData) => {
    console.log('formdatawarranty', formData);

    const errors = {};
    let isValid = true;
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = 'This field is required';
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const confirmation = await Swal.fire({
      title: 'Add Warranty',
      text: 'Are you sure you want to add this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    if (confirmation.isConfirmed) {
      try {
        setLoading(true);

        const initialPayload = {
          warranty_type: formData.warrentytype,
          warranty_category: 'Y',
          warranty_name: formData.warranty_name,
          warranty_value: formData.warrantyvalue,
          warranty_desc: formData.warranty_desc,
          status: formData.status === true ? 1 : 0,
          isReplacementWarranty: formData.isReplacementWarranty,
        };

        const payload = formData.isReplacementWarranty
          ? {
              ...initialPayload,
              warranty_replace_value: formData.isReplacementWarranty
                ? formData.warranty_replace_value
                : null,
            }
          : initialPayload;

        const response = await axiosInstance.post('/warranty/create', payload, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        });
        await Swal.fire({
          title: 'Success',
          text: 'Warranty added successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        if (response.status === 200) {
          navigate(ROUTES_NAVIGATION.WARRANTY);
        }
      } catch (error) {
        console.error('Error adding warranty:', error);
        const errorMessage =
          error.response?.data?.message ||
          'An error occurred while processing your request.';
        await Swal.fire({
          title: 'Something went wrong',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const backNavigate = () => {
    navigate(ROUTES_NAVIGATION.WARRANTY);
  };

  const CustomerInputs = [
    {
      name: 'warranty_name',
      label: 'Warranty',
      type: 'text',
      placeholder: 'Enter Warranty Name',
      required: true,
      validation: validations.warrantyName({ required: true }),
      gridClass: 'col-lg-4',
    },
    // {
    //   name: "warrantycategory",
    //   label: "Warranty Category",
    //   type: "dropdown",
    //   required: true,
    //   options: warrantycategory,
    //   validation: { required: true },
    //   gridClass: "col-lg-4",
    // },
    // ...(formData?.warrantycategory === "Y"
    //   ? [
    {
      name: 'warrentytype',
      label: 'Warranty Type',
      placeholder: 'Enter Warranty Value',
      type: 'dropdown',
      options: warrantyTypeData,
      required: true,
      validation: { required: true },
      gridClass: 'col-lg-4',
    },
    //   ]
    // : []),
    {
      name: 'warrantyvalue',
      label: 'Warranty Repair Period',
      type: 'number',
      placeholder: 'Enter Period',
      required: true,
      validation: validations.warrantyValue({ required: true }),
      // validation: {
      //   required: true,
      //   pattern: /^(?:0|[1-9]\d*)$/,
      //   minLength: 1,
      //   maxLength: 5,
      //   message: "Warranty Value must be a non-negative whole number",
      // },
      gridClass: 'col-lg-4',
    },
    {
      name: 'warranty_desc',
      label: 'Warranty Description',
      type: 'text',
      placeholder: 'Enter Warranty Description',
      required: true,
      validation: validations.description({ required: true }),
      gridClass: 'col-lg-4',
    },
    {
      name: 'isReplacementWarranty',
      label: 'Is Warranty Replaceable?',
      type: 'toggle',
      gridClass: 'col-lg-4',
    },
    ...(formData?.isReplacementWarranty === true
      ? [
          {
            name: 'warranty_replace_value',
            label: 'Warranty Replacement Period',
            type: 'number',
            placeholder: 'Enter Period',
            required: true,
            validation: validations.warrantyValue({ required: true }),
            // validation: {
            //   required: true,
            //   pattern: /^(?:0|[1-9]\d*)$/,
            //   minLength: 1,
            //   maxLength: 5,
            //   message: "Warranty Value must be a non-negative whole number",
            // },
            gridClass: 'col-lg-4',
          },
        ]
      : []),
    {
      name: 'status',
      label: 'Status',
      type: 'toggle',
      gridClass: 'col-lg-4',
    },
  ];

  useEffect(() => {
    if (
      prevWarrantyTypeRef.current !== undefined &&
      prevWarrantyTypeRef.current !== formData?.warrentytype
    ) {
      setFormData((prev) => ({
        ...prev,
        warrantyvalue: '',
      }));
    }
    prevWarrantyTypeRef.current = formData?.warrentytype;
  }, [formData]);

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img onClick={backNavigate} src={backicon} alt="back" />
              <span className="backbtntitle">Add Warranty</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter the warranty details
              </span>
              <DynamicForm
                formConfig={CustomerInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>

            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(CustomerInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  CustomerInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => {
                  handleFormSubmit(formData);
                }}
              >
                {loading ? 'Processing...' : 'Submit'}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddWarranty;
